import { Box, Chip, Typography } from '@mui/material';
import {
  ARTICLE_CONTENT_TYPES,
  ARTICLE_PUBLICATION_STATUSES,
  CONTENT_TYPE_LABELS,
  PUBLICATION_STATUS_LABELS,
} from '../../utils/articleItemMediaUtils';

const chipBaseSx = {
  fontFamily: 'Mulish',
  fontWeight: 600,
  fontSize: '0.75rem',
  height: 26,
};

const PUBLICATION_STATUS_CHIP_SX = {
  [ARTICLE_PUBLICATION_STATUSES.draft]: { bgcolor: '#FFF4E5', color: '#B45309' },
  [ARTICLE_PUBLICATION_STATUSES.published]: { bgcolor: '#E8F5E9', color: '#2E7D32' },
  [ARTICLE_PUBLICATION_STATUSES.archived]: { bgcolor: '#F3F4F6', color: '#6B7280' },
};

const CONTENT_TYPE_CHIP_SX = {
  [ARTICLE_CONTENT_TYPES.document]: { bgcolor: '#E3F2FD', color: '#1565C0' },
  [ARTICLE_CONTENT_TYPES.photos]: { bgcolor: '#F3E5F5', color: '#7B1FA2' },
  [ARTICLE_CONTENT_TYPES.video]: { bgcolor: '#FFF3E0', color: '#E65100' },
};

export const ArticlePublicationStatusChip = ({ status, size = 'small' }) => (
  <Chip
    label={PUBLICATION_STATUS_LABELS[status] || status}
    size={size}
    sx={{ ...chipBaseSx, ...PUBLICATION_STATUS_CHIP_SX[status] }}
  />
);

export const ArticleContentTypeChip = ({ contentType, size = 'small' }) => (
  <Chip
    label={CONTENT_TYPE_LABELS[contentType] || contentType}
    size={size}
    sx={{ ...chipBaseSx, ...CONTENT_TYPE_CHIP_SX[contentType] }}
  />
);

export const ArticleContentTypeReadonlyField = ({ contentType }) => (
  <Box className="addUser_helper_selct_box">
    <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
      <Typography className="addUserInputTitle" component="span" sx={{ mb: 0 }}>
        Type de contenu :
      </Typography>
      <ArticleContentTypeChip contentType={contentType} />
    </Box>
  </Box>
);

export default ArticleContentTypeReadonlyField;
